import React from "react";
import styled from "styled-components";
import SvgError from "../../SvgAnimations/Error.js";

export const ContentModal = styled.div`
  display: flex;

  width: 100%;
  height: fit-content;
  padding: 24px;
  background: var(--bg-floating);
  border-radius: 8px;
  flex-direction: column;
  overflow: hidden;
  gap: 32px;

  text-align: center;

  @media (max-width: 578px) {
    width: 400px !important;
  }
  @media (max-width: 370px) {
    width: 350px !important;
  }
`;

export const Title = styled.h6`
  margin: 0;
  color: var(--fg-neutral-strong);
  line-height: 140%;
  font-weight: 600;
`;
export const SubTitle = styled.span`
  margin: 0;
  color: var(--fg-neutral-subtle);
  font-weight: 400;
  line-height: 140%;
`;
export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;
export const ButtonModal = styled.button`
  width: fit-content;
  min-width: 80% !important;
  height: 40px !important;
  padding: 10px 40px 10px 40px !important;
  gap: 10px;
  color: var(--fg-neutral-subtler) !important;
  border-radius: 5px !important;
  opacity: 0px;
  text-transform: none !important;
  font: normal 600 14px "Noto Sans" !important;
  background: var(--bg-brand-default) !important;
  border: none;

  align-self: center;

  &:hover {
    background-image: linear-gradient(var(--state-hover), var(--state-hover)) !important;
  }

  html[data-theme="dark"] &:hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.16), rgba(0, 0, 0, 0.16)) !important;
  }
`;

export default function Failed(props) {
  return (
    <ContentModal>
      <TextContent>
        <SvgError />
        <Title>{props.title}</Title>
        <SubTitle>{props.subTitle}</SubTitle>
      </TextContent>
      <ButtonModal onClick={props.close}>Usar outro cartão</ButtonModal>
    </ContentModal>
  );
}
